module.exports = __webpack_public_path__ + "d92df3c700eb58efcc94a67834f28568.svg";